module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getload),
      expression: "getload"
    }],
    attrs: {
      "id": "loadingToast"
    }
  }, [_c('div', {
    staticClass: "weui-mask",
    staticStyle: {
      "opacity": "1"
    },
    attrs: {
      "id": "iosMask"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-toast"
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v("数据加载中")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-553f0dc1"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xload.vue
// module id = 261
// module chunks = 0